import type { AiService } from '@/context/services/ai_service_setting/type';
import { useTranslation } from '@/i18n';
import { Caption } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, PropsWithChildren } from 'react';
import { SingleRow } from '../../Common';
import { ServiceContent } from './ServiceContent';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type Props = {
  service: AiService;
};

export const ServiceRow: FC<PropsWithChildren<Props>> = ({
  service,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <SingleRow
      label={
        <div className={cx(styles['serviceLabel'])}>
          <div>
            <p>{service.name}</p>
            {service.alias_name && <p>({service.alias_name})</p>}
          </div>
          {service.is_metered && (
            <Caption type='helper'>
              {t('ai_service_setting.metered_label')}
            </Caption>
          )}
        </div>
      }
      renderContent={
        <ServiceContent service={service}>{children}</ServiceContent>
      }
    />
  );
};

ServiceRow.displayName = 'ApAiServiceSettingsServiceRow';
